<template>
    <div class="tests-overview">
        <design-2021-apprentice-multistep-form-wizard-form-header-component
            :title="$t('testcenter.choose_a_test')"
            :description="description">
        </design-2021-apprentice-multistep-form-wizard-form-header-component>

        <div
            class="errors"
            v-if="hasError">
            <b-alert
                class="test-select-error"
                show
                variant="danger">
                {{ $t('testcenter.you_dont_have_a_test_selected') }}
            </b-alert>
        </div>

        <div class="tests">
            <div
                class="test-card apprentice-simple-card"
                v-for="test in paginatedTests[currentPage-1]"
                :class="{ active: selectedTest.id === test.id }"
                :key="test.id"
                @click="selectTest(test)"
                dusk="test-card">
                <h4 class="title">{{ test.title }}</h4>
                <div
                    class="description"
                    v-html="test.short_description ?? test.description"></div>
                <b-button
                    class="btn-play btn-test-preview"
                    variant="primary"
                    @click.prevent.stop="showTestPreviewModal(test)"
                    dusk="preview-test-button">
                    {{ $t('testcenter.preview') }}
                </b-button>
                <a
                    class="clickable"
                    href="#">
                </a>
            </div>

            <div class="pagination-bar">
                <b-pagination
                    class="d-flex justify-content-center"
                    v-model="currentPage"
                    first-class="go-to-first-page"
                    last-class="go-to-last-page"
                    next-class="nex-page"
                    prev-class="previous-page"
                    page-class="page"
                    :total-rows="paginatedTests.length * pageSize"
                    :per-page="pageSize">
                    <template #first-text>
                        <i class="far fa-fw fa-chevron-double-left"></i>
                    </template>

                    <template #prev-text>
                        <i class="far fa-fw fa-chevron-left"></i>
                    </template>

                    <template #next-text>
                        <i class="far fa-fw fa-chevron-right"></i>
                    </template>

                    <template #last-text>
                        <i class="far fa-fw fa-chevron-double-right"></i>
                    </template>
                </b-pagination>
            </div>
        </div>

        <design-2021-test-preview-modal-component ref="testPreviewModal"></design-2021-test-preview-modal-component>
    </div>
</template>

<script>
import Design2021TestPreviewModalComponent from '../modals/design-2021-test-preview-modal-component.vue';

export default {
    name: 'design-2021-test-center-issuing-wizard-tests-overview-component',
    components: { Design2021TestPreviewModalComponent },
    props: {
        testsIn: {
            type: Array,
            required: true
        },

        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        paginatedTests() {
            let paginatedArray = [];
            const testsCopy = this.testsIn.map((object) => ({ ...object }));

            for (let i = 0; i < testsCopy.length; i += this.pageSize) {
                paginatedArray.push([...testsCopy.slice(i, i + this.pageSize)]);
            }

            return paginatedArray;
        }
    },
    data() {
        return {
            tests: this.value,
            selectedTest: {},
            hasError: false,
            description: this.$t('testcenter.choose_test_description'),
            currentPage: 1,
            pageSize: 4
        };
    },
    methods: {
        showTestPreviewModal(test) {
            this.$refs.testPreviewModal.show(test);
        },

        selectTest(test) {
            this.selectedTest = { ...test };
            this.$emit('input', { ...test });
        },

        async checkForErrors() {
            this.hasError = Object.keys(this.selectedTest).length === 0 && this.selectedTest.constructor === Object;

            return this.hasError;
        }
    }
};
</script>

<style scoped lang="scss">
.description ::v-deep {
    line-height: 1.5;
    font-size: $base-font-size;
    text-align: left;

    .sub-title {
        line-height: 1.5;
        margin-bottom: 0;
        font-weight: $font-weight-bold;
        font-size: 1.125rem;
        margin-top: map-get($grid-gutter-spacing, 'twenty-one');
    }
}

.tests-overview {
    > .description {
        color: $text-muted-color;
        font-weight: $font-weight-medium;
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    }
}

.tests {
    display: flex;
    justify-content: space-between;
    gap: $grid-gutter-width;
    flex-wrap: wrap;
}

.test-card {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    position: relative;
    background-color: $secondary-background-color;
    border: 2px solid transparent;

    .title {
        line-height: 1.5;
        margin-bottom: 0;
        font-weight: $font-weight-bold;
    }

    .description {
        line-height: 1.5;
        font-size: $default-font-size;
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }

    &.active {
        border: 2px solid $primary;
    }

    &:hover {
        cursor: pointer;
        box-shadow: 1px 0px 4px $border-color;
        border: 2px solid $primary;
    }

    &:not(:last-child) {
        margin-bottom: 0;
    }
}

.btn-test-preview {
    align-self: flex-end;
    margin-top: auto;
    z-index: 55;
    width: 100%;
}

.pagination-bar {
    margin-top: 20px;
    align-content: center;
    width: 100%;
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .test-card {
        .btn-test-preview {
            width: auto;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xxl')) {
    .test-card {
        flex: 0 0 calc(50% - 15px);
    }
}
</style>
